// react-redux imports
import { useSelector } from "react-redux";
import { useHistory, Switch, Route } from "react-router-dom";
import { useLocation } from "react-router";
import { CSSTransition } from "react-transition-group";
import { RootState } from "./store";

import Admin from "features/admin/Admin";
import Background from "features/background/Background";
import Calculator from "features/calculator/Calculator";
import Factors from "features/factors/Factors";
import Header from "features/header/Header";
import Home from "features/home/Home";
import Menu from "features/menu/Menu";
import Results from "features/result/Result";

import Footer from "common/components/Footer";
import Wrapper from "common/components/styled-components/Wrapper";

import NonFooterWrapper from "./styled-components/NonFooterWrapper";
import { useEffect } from "react";
import { trackPageView } from "features/cookie-banner/gtm-functions";

function App() {
  const location = useLocation();
  const isAdmin = location.pathname === "/admin";
  const isMenuOpen = useSelector(
    (state: RootState) => state.header.menu.isMenuOpen
  );

  const history = useHistory();

  useEffect(() => {
    trackPage(); // To track the first pageview upon load
    history.listen(trackPage); // To track the subsequent pageviews
  }, [history]);

  function trackPage() {
    trackPageView(window.location.pathname);
  }

  return (
    <Wrapper>
      <NonFooterWrapper>
        {!isAdmin && (
          <>
            <Background />
            <Header />
          </>
        )}
        <CSSTransition
          timeout={500}
          classNames="menu"
          in={isMenuOpen}
          unmountOnExit
          appear
        >
          <Menu />
        </CSSTransition>
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>

          <Route exact path="/factors">
            <Factors />
          </Route>

          <Route exact path="/calculator">
            <Calculator />
          </Route>

          <Route exact path="/calculator/result">
            <Results />
          </Route>

          <Route exact path="/admin">
            <Admin />
          </Route>
        </Switch>
      </NonFooterWrapper>
      {!isAdmin && <Footer />}
    </Wrapper>
  );
}

export default App;
